// CdrTimezoneSelector.jsx
//
// Compact MUI TextField (select) used in the CDR Report header to let the
// operator pick which timezone the page renders its datetime columns in. The
// chosen value is persisted to localStorage by this component (callers don't
// need to remember to call saveTimezone themselves).

import React from "react";
import { MenuItem, TextField, Tooltip } from "@mui/material";
import { TIMEZONE_OPTIONS, saveTimezone } from "../../utils/cdrTimezone";

export default function CdrTimezoneSelector({ value, onChange, sx }) {
  const handleChange = (e) => {
    const next = e.target.value;
    saveTimezone(next);
    if (typeof onChange === "function") onChange(next);
  };

  return (
    <Tooltip title="Display times in this timezone. Saved per browser." arrow>
      <TextField
        select
        size="small"
        label="Timezone"
        value={value}
        onChange={handleChange}
        InputLabelProps={{ shrink: true }}
        sx={{
          minWidth: 230,
          maxWidth: 280,
          "& .MuiInputBase-root": { fontSize: "13px" },
          "& .MuiInputLabel-root": { fontSize: "13px" },
          ...sx,
        }}
      >
        {TIMEZONE_OPTIONS.map((opt) => (
          <MenuItem key={opt.value} value={opt.value} sx={{ fontSize: "13px" }}>
            {opt.label}
          </MenuItem>
        ))}
      </TextField>
    </Tooltip>
  );
}
